import styled from '@xstyled/styled-components'

export const ProductImageZoomWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 8 2;
  overflow-y: scroll;
  background-color: white;
  z-index: 100;
  display: flex;
  flex-direction: column;
  .container {
    position: relative;
  }
  img {
    display: block;
    margin: 0 auto;
    margin-bottom: 4;
    max-height: calc(100vh - 80px);

    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const ZoomCloseButton = styled.button`
  color: black;
  cursor: pointer;
  position: absolute;
  top: -22px;
  right: 22px;
  font-size: 4;
  font-family: serif;
`
